import _ from 'underscore'
import Sortable from 'sortablejs'

import swal from 'sweetalert2'
import Rails from '@rails/ujs'

import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'

import 'chartkick/chart.js'
Chartkick.configure({language: "fr"})

// require('../libs/craft/scripts.bundle');
import { KTImageInput } from '../libs/craft/scripts.bundle'

import Trix from 'trix'

// jQuery is loaded via CDN and available as window.$ / window.jQuery

require('@rails/ujs').start()
require('turbolinks').start()

require('@claviska/jquery-minicolors')

require('jquery-ui-dist/jquery-ui')

const select2Lang = $('html').attr('lang').split('-')[0]
require('select2/dist/js/select2.full')
require(`select2/dist/js/i18n/${select2Lang}.js`)
// require('select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css')

window.bootstrap = require('bootstrap')

import Coloris from '@melloware/coloris'
window.Coloris = Coloris
Coloris.init()
Coloris({ el: '.coloris' })
$(document).on('shown.bs.modal', '.modal', function () {
  Coloris({ el: '.coloris', parent: '.modal' })
});

// Override Rails data-confirm behaviour
Rails.confirm = function (message, element) {
  if (element.getAttribute('data-typeview') === 'modal') {
    const setting = {
      title: element.getAttribute('data-title'),
      message,
      appendTo: element.getAttribute('data-appendto'),
      buttons: element
    }
    confirmationDialog(setting).then(() => {
      element.removeAttribute('data-confirm')
      element.click()
    }).catch((error) => {})
  } else {
    const title = element.getAttribute('data-title')
    const htmldata = (title ? '<p class="swal-title fs-4 fw-bold mb-0">' + title + '</p><p class="swal-message mt-4">' + message + '</p>' : '<p class="swal-title fs-2 fw-bold mb-0">' + message + '</p>')
    const swalWithBootstrap = swal.mixin({
      customClass: {
        popup: 'p-8',
        cancelButton: 'btn btn-light me-4',
        confirmButton: 'btn btn-primary'
      },
      focusConfirm: false,
      buttonsStyling: false,
      reverseButtons: true
    })

    swalWithBootstrap.fire({
      html: htmldata,
      showCancelButton: true,
      confirmButtonText: I18n.app.yes,
      cancelButtonText: I18n.app.no
    }).then((result) => {
      if (result.value) {
        element.removeAttribute('data-confirm')
        element.click()
      }
    })
  }
}

document.addEventListener('turbolinks:load', function () {
  $('.toast').each(function () {
    $(this).toast('show')
  })

  $(document).on('shown.bs.modal', '.modal', function () {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    setupSelect2InModal()
  })

  //= ===========================================================##
  // Select2
  //= ===========================================================##
  $.fn.select2.defaults.set('theme', 'bootstrap5')
  $.fn.select2.defaults.set('containerCssClass', ':all:')
  $.fn.select2.defaults.set('width', '100%')
  setupSelect2Base()

  //= ===========================================================##
  // Flatpickr
  //= ===========================================================##
  setupFlatPickr()

  //= ===========================================================##
  // Craft / Flatpickr
  //= ===========================================================##
  ktimageinput()

  //= ===========================================================##
  // MiniColors
  //= ===========================================================##
  $('#youtube_scenario_color').minicolors({ theme: 'bootstrap' })
  $('#template_pdf_color').minicolors({ theme: 'bootstrap' })

  //= ===========================================================##
  // To Drag and Drop Table and save order to database
  //= ===========================================================##
  _.each(['scenarios', 'templatepdfs', 'categories'], function (name) {
    if ($(`.${name}-table`).length) {
      _.each($(`.${name}-table`), function (div) {
        var sortable = Sortable.create($(div)[0], {
          onUpdate: function (evt) {
            $.ajax({
              type: 'POST',
              url: $(`.${name}-table`).data('sort_url'),
              data: {
                my_order: sortable.toArray()
              }
            })
          }
        })
      })
    }
  })

  // Signin password reveal
  $('.password-revealer').on('click', function () {
    $(this).toggleClass('revealed')

    const input = $('.password-revealable')

    if (input.attr('type') == 'password') {
      input.attr('type', 'text')
    } else {
      input.attr('type', 'password')
    }
  })
})

window.enableSortable = (table_id) => {
  _.each($(table_id), function (div) {
    var sortable = Sortable.create($(div)[0], {
      onUpdate: function (evt) {
        $.ajax({
          type: 'POST',
          url: $(table_id).data('sort_url'),
          data: {
            my_order: sortable.toArray()
          }
        })
      }
    })
  })
}

window.fillCollapsableCategories = (node) => {
  if (!$(node).hasClass('shown')) {
    $.ajax({
      url: $(node).data('url'),
      type: 'GET',
      dataType: 'script'
    })
  }
}

window.setupDateTimePicker = () => {
  setupFlatPickr()
  setupFlatPickrTime()
}

window.setupFlatPickr = () => {
  flatpickr('.datepicker', {
    locale: French,
    dateFormat: 'd/m/Y'
  })
}

window.setupFlatPickrTime = () => {
  flatpickr('.timepicker', {
    locale: French,
    dateFormat: 'H:i',
    enableTime: true,
    noCalendar: true
  })
}

window.setupSelect2Base = () => {
  $('.select2, select.form-control:not(.no-select2)').each(function () {
    setupASelect2Base($(this))
  })
}

window.setupSelect2InModal = () => {
  $('.select2, select.form-control:not(.no-select2)').each(function () {
    setupASelect2InModal($(this))
  })
}

window.setupASelect2Base = (target) => {
  target.select2({
    theme: 'bootstrap5',
    minimumResultsForSearch: 8,
    width: '100%',
    closeOnSelect: !target.prop('multiple'),
    language: $('html').attr('lang'),
    selectionCssClass: ':all:'
  })
}

window.setupASelect2InModal = (target) => {
  target.select2({
    theme: 'bootstrap5',
    minimumResultsForSearch: 8,
    dropdownParent: target.closest('.modal').length && !target.prop('multiple') ? target.closest('.modal') : null,
    width: '100%',
    closeOnSelect: !target.prop('multiple'),
    language: $('html').attr('lang'),
    selectionCssClass: ':all:'
  })
}

window.setupKTImageInput = () => {
  ktimageinput()
}

window.ktimageinput = () => {
  KTImageInput.createInstances()
}

window.findCountriesLocalities = () => {
  $('#article_countries').on('select2:select, select2:unselect', function (e) {
    spin(true)
    $.ajax({
      url: '/admin/articles/get_country_localities',
      type: 'get',
      data: {
        country_ids: $('#article_countries').val()
      },
      dataType: 'script',
      success: function success (data) {
        $('#article_localities').html('')
        let select = ''
        select += '<select class="select2" name="article[locality_id]" id="article_localities">'
        select += '<option value="">Select Locality</option>'
        JSON.parse(data).forEach(function (locality, index) {
          select += '<option value="' + locality.id + '">' + locality.name + '</option>'
        })
        select += '</select>'
        $('#article_localities').html(select)
      },
      error: function (jqXHR, exception) {
        $('#article_localities').val('')
      }
    })
    spin(false)
  })
}

window.findFranchiseCategories = () => {
  $('#franchisor_ids_options').on('change', function (e) {
    $('#franchisor_categories').empty()

    $.ajax({
      url: '/admin/special_days/load_franchisor_categories',
      type: 'get',
      data: {
        franchisor_ids: $(this).val()
      },
      dataType: 'json',
      success: function success (response) {
        Object.entries(response).forEach(([key, value], index) => {
          let select = ''

          const selected_value = $('#fr_category_' + key).val()
          const generic_category = value.find(function (category) { return category.name === 'Générique' })
          select += `<label class='form-label' for="franchisor_cat_${index}">${key}</label>`
          select += `<select class="form-select form-control mb-5" name="fr_category_ids[]" id="franchisor_cat_${index}" data-franchisor="${key}" multiple>`
          value.forEach(function (category, index) {
            if ((selected_value === undefined) && (generic_category.id == category.id)) {
              select += '<option value="' + generic_category.id + '" selected="selected">' + generic_category.name + '</option>'
            } else if (parseInt(selected_value) == category.id) {
              select += '<option value="' + category.id + '" selected="selected">' + category.name + '</option>'
            } else {
              select += '<option value="' + category.id + '">' + category.name + '</option>'
            }
          })

          select += '</select>'

          $('#franchisor_categories').append(select)

          setupASelect2($(`select#franchisor_cat_${index}`))
        })
      },
      error: function (jqXHR, exception) {
        $('#franchisor_categories').val('')
      }
    })
  })
}

window.getArticleSource = () => {
  $('#article_link').on('focusout', function () {
    const article_link = $('#article_link :input').val()
    if (article_link != '') {
      const domain = getDomainName($('#article_link :input').val())
      $('#article_source :input').val(domain)
    } else {
      $('#article_source :input').val('')
    }
  })
}

const getDomainName = (hostName) => {
  return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1)
}

require('../admin_scripts/specialDay')
require('../admin_scripts/mls')
require('./modals/special-day-form')
require('./modals/review_caption_template_create_edit_modal')